/* Axiom Supply — Pre-order lead-time popup.
 * <axiom-preorder> wraps any add-to-cart surface (product form, quick-add form,
 * bulk quick-add stepper). First add click is intercepted in the capture phase and
 * a themed <dialog> shows the lead-time message; "Add to Cart" re-fires the original
 * click and the native flow (product-form.js AJAX -> cart drawer) proceeds untouched.
 * Data attributes: data-title, data-message, data-confirm, data-cancel.
 */
if (!customElements.get('axiom-preorder')) {
  class AxiomPreorder extends HTMLElement {
    connectedCallback() {
      if (this.axiomBound) return;
      this.axiomBound = true;
      this.confirmed = false;
      this.addEventListener('click', this.handleClick.bind(this), true);
    }

    handleClick(event) {
      if (this.confirmed) return;
      const trigger = event.target.closest('button[name="add"], button[name="plus"]');
      if (!trigger || !this.contains(trigger) || trigger.disabled) return;
      // "Choose Options"-style buttons only open a modal, nothing is added yet —
      // the surfaces inside that modal are wrapped themselves.
      if (trigger.closest('modal-opener')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      this.openDialog(trigger);
    }

    getDialog() {
      let dialog = document.getElementById('AxiomPreorderDialog');
      if (!dialog) {
        dialog = document.createElement('dialog');
        dialog.id = 'AxiomPreorderDialog';
        dialog.className = 'axiom-preorder__dialog color-scheme-1 gradient';
        dialog.innerHTML = `
          <div class="axiom-preorder__inner">
            <p class="axiom-preorder__eyebrow"></p>
            <h2 class="axiom-preorder__title"></h2>
            <p class="axiom-preorder__message"></p>
            <div class="axiom-preorder__actions">
              <button type="button" class="button button--secondary" data-axiom-preorder-cancel></button>
              <button type="button" class="button button--primary" data-axiom-preorder-confirm autofocus></button>
            </div>
          </div>`;
        document.body.appendChild(dialog);
        dialog.addEventListener('click', (e) => {
          if (e.target === dialog) dialog.close();
        });
      }
      return dialog;
    }

    openDialog(trigger) {
      const dialog = this.getDialog();
      dialog.querySelector('.axiom-preorder__eyebrow').textContent = 'Pre-Order';
      dialog.querySelector('.axiom-preorder__title').textContent = this.dataset.title || 'Heads up — this is a pre-order';
      dialog.querySelector('.axiom-preorder__message').textContent =
        this.dataset.message ||
        'This item is available for pre-order. We are currently running a 2–3 week lead time — your order will ship as soon as it is ready.';
      const confirmButton = dialog.querySelector('[data-axiom-preorder-confirm]');
      const cancelButton = dialog.querySelector('[data-axiom-preorder-cancel]');
      confirmButton.textContent = this.dataset.confirm || 'Add to Cart';
      cancelButton.textContent = this.dataset.cancel || 'Cancel';
      confirmButton.onclick = () => {
        this.confirmed = true;
        dialog.close();
        trigger.click();
      };
      cancelButton.onclick = () => dialog.close();
      dialog.showModal();
    }
  }

  customElements.define('axiom-preorder', AxiomPreorder);
}
